import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";


export function YesNoDialog({showDialog, dialogTitle, yesButtonPressed, noButtonPressed}) {
    return (
        <Dialog
            maxWidth="xs"
            open={showDialog}
        >
            <DialogTitle>{dialogTitle} </DialogTitle>
            <DialogActions>
                <Button onClick={noButtonPressed}>
                    No
                </Button>
                <Button onClick={yesButtonPressed}>Yes</Button>
            </DialogActions>
        </Dialog>
    );
}
